import * as React from 'react'
import { ExternalLink as ExternalLinkIcon } from 'react-feather'

import { Button } from 'main/ui'
import { ContentContainer, LabelStrong } from './EditButton.styles'

interface IProps {
  onClick: () => void
}

export default function EditButton({ onClick }: IProps) {
  return (
    <Button onClick={onClick}>
      <ContentContainer>
        <ExternalLinkIcon />
        <LabelStrong>Edit my website</LabelStrong>
      </ContentContainer>
    </Button>
  )
}
